import { Button } from "components/Button";
import styled from "styled-components/macro";

export const StyledButton = styled(Button)`
  width: fit-content;
`;
